/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Account Role
 * @export
 */
export const AccountRole = {
    Superadmin: 'superadmin',
    Admin: 'admin',
    User: 'user'
} as const;
export type AccountRole = typeof AccountRole[keyof typeof AccountRole];


export function instanceOfAccountRole(value: any): boolean {
    for (const key in AccountRole) {
        if (Object.prototype.hasOwnProperty.call(AccountRole, key)) {
            if (AccountRole[key as keyof typeof AccountRole] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AccountRoleFromJSON(json: any): AccountRole {
    return AccountRoleFromJSONTyped(json, false);
}

export function AccountRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountRole {
    return json as AccountRole;
}

export function AccountRoleToJSON(value?: AccountRole | null): any {
    return value as any;
}

